"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createD2CMessage = void 0;
const effect_1 = require("effect");
const date_1 = require("../../../date");
const message_1 = require("./message");
const createD2CMessage = (namespace, alarms) => {
    const AlarmPayload = effect_1.Schema.Union(...alarms.map(Alarm => {
        const RaiseAlarm = effect_1.Schema.Struct({
            _tag: effect_1.Schema.optionalWith(effect_1.Schema.Literal('Raise'), {
                exact: true,
                default: () => 'Raise',
            }),
            time: date_1.Timestamp,
            alarm: Alarm,
        }).annotations(effect_1.Record.getSomes({
            title: effect_1.SchemaAST.getTitleAnnotation(Alarm.ast.to).pipe(effect_1.Option.map(title => `Raise: ${title}`)),
        }));
        const DismissAlarm = effect_1.Schema.TaggedStruct('Dismiss', {
            time: date_1.Timestamp,
            alarm: Alarm,
        }).annotations(effect_1.Record.getSomes({
            title: effect_1.SchemaAST.getTitleAnnotation(Alarm.ast.to).pipe(effect_1.Option.map(title => `Dismiss: ${title}`)),
        }));
        const DismissAnyAlarm = effect_1.Schema.TaggedStruct('DismissAny', {
            time: date_1.Timestamp,
            alarm: effect_1.Schema.TaggedStruct(Alarm._tag, {}),
        }).annotations(effect_1.Record.getSomes({
            title: effect_1.SchemaAST.getTitleAnnotation(Alarm.ast.to).pipe(effect_1.Option.map(title => `Dismiss Any: ${title}`)),
        }));
        return effect_1.Schema.Union(RaiseAlarm, DismissAlarm, DismissAnyAlarm).annotations(effect_1.Record.getSomes({
            title: effect_1.SchemaAST.getTitleAnnotation(Alarm.ast.to),
        }));
    }));
    const DismissAllAlarms = effect_1.Schema.TaggedStruct('DismissAll', {
        time: date_1.Timestamp,
    }).annotations({
        title: 'Dismiss All Alarms',
    });
    return (0, message_1.createMessage)('alarm', effect_1.Schema.Union(AlarmPayload, DismissAllAlarms)).annotations({
        identifier: `${namespace}.AlarmD2CMessage`,
        title: 'Alarm Message',
        description: 'A Device-To-Cloud message on the "alarm" channel',
    });
};
exports.createD2CMessage = createD2CMessage;
//# sourceMappingURL=alarm.js.map